import React, { useState } from 'react';
import DocumentDebug from '../components/document/DocumentDebug';

function HomePage() {
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callAzureFunction = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Use relative path to take advantage of Static Web Apps routing/proxy
      // or setup a proxy in package.json for local development
      const response = await fetch('https://slfuncdemo2.azurewebsites.net/api/FuncMeBaby', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name }),
      });

      if (!response.ok) {
        throw new Error(`Function returned status: ${response.status}`);
      }

      const data = await response.text();
      setMessage(data);
    } catch (error) {
      setError(error.message);
      setMessage('');
      console.error('Error calling Azure Function:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Searchlight.QWriter2025</h1>
      <p>
        Azure Static Web App with React frontend and .NET Core Functions.
      </p>
      
      {/* Add the Document Debug component */}
      <DocumentDebug />
      
      <p>
        This demo connects to the external Azure Function at:<br/>
        <code>slfuncdemo2.azurewebsites.net/api/FuncMeBaby</code><br/>
      </p>
      
      <div className="form-container">
        <input 
          type="text" 
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter your name"
          style={{ 
            padding: '10px', 
            marginRight: '10px',
            fontSize: '16px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '100%',
            marginBottom: '15px'
          }}
        />
        
        <button 
          onClick={callAzureFunction}
          disabled={loading}
          className="btn-primary"
          style={{
            width: '100%',
            opacity: loading ? 0.7 : 1,
            cursor: loading ? 'wait' : 'pointer'
          }}
        >
          {loading ? 'Calling Function...' : 'Call External Function'}
        </button>
      </div>
      
      {message && (
        <div className="alert" style={{ backgroundColor: 'rgba(0,120,212,0.1)' }}>
          <strong>Response:</strong> {message}
        </div>
      )}
      
      {error && (
        <div className="alert alert-error">
          <strong>Error:</strong> {error}
          <p style={{ marginTop: '10px', fontSize: '14px' }}>
            Note: If you're seeing connection errors, this might be because the proxy is not properly configured 
            or the external function is not available. Try restarting the development server after changing the proxy settings.
          </p>
        </div>
      )}
    </div>
  );
}

export default HomePage;